import { Logout } from "@mui/icons-material";
import { AppBar, Box, Button, Container, Toolbar, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { useGetIdentity, useLogout, useTranslate } from "react-admin";
import { Link } from "react-router-dom";

import { Logo } from "../components/icons/logo";
import { color, space } from "../theme/designTokens";

export const LearningLayout = ({ children }: { children: ReactNode }) => {
  const { data: identity } = useGetIdentity();
  const logout = useLogout();
  const translate = useTranslate();

  return (
    <Box data-testid="learning-layout" sx={{ minHeight: "100vh", backgroundColor: color.background2 }}>
      <AppBar position="static" color="inherit" elevation={0} sx={{ borderBottom: `1px solid ${color.panelBorder}` }}>
        <Toolbar sx={{ gap: space.md }}>
          <Box component={Link} to="/learning" aria-label={translate("learning.home")} sx={{ display: "flex" }}>
            <Logo />
          </Box>
          <Typography component="p" sx={{ flex: 1, color: color.typographyBase }}>
            {identity?.fullName}
          </Typography>
          <Button
            data-testid="learning-logout"
            startIcon={<Logout />}
            onClick={() => logout()}
            sx={{ color: color.typographyBase }}
          >
            {translate("learning.logout")}
          </Button>
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="lg" sx={{ py: space.xxl1 }}>
        {children}
      </Container>
    </Box>
  );
};
